import { customMutator } from "@/networking/axios"

import type { GetInterBuExcelExportData200 } from "./types"

export const getInterBuExcelExportData = (locale?: string, signal?: AbortSignal) => {
  return customMutator<GetInterBuExcelExportData200>({
    url: "/api/shared-datas/interbu/excel-export",
    method: "GET",
    params: locale ? { locale } : undefined,
    signal,
  })
}
